export const GET_TAGS_REQUEST = 'GET_TAGS_REQUEST';
export const GET_ASSIGNABLE_TAGS_REQUEST = 'GET_ASSIGNABLE_TAGS_REQUEST';
export const CREATE_TAG_REQUEST = 'CREATE_TAG_REQUEST';
export const UPDATE_TAG_REQUEST = 'UPDATE_TAG_REQUEST';
export const DELETE_TAG_REQUEST = 'DELETE_TAG_REQUEST';
export const RESTORE_TAG_REQUEST = 'RESTORE_TAG_REQUEST';
export const GET_TAG_USAGE_REQUEST = 'GET_TAG_USAGE_REQUEST';
export const SET_TAG_ASSIGNMENTS_REQUEST = 'SET_TAG_ASSIGNMENTS_REQUEST';
export const GET_INHERITED_TAGS_REQUEST = 'GET_INHERITED_TAGS_REQUEST';
export const GET_TAG_DETAIL_REQUEST = 'GET_TAG_DETAIL_REQUEST';
export const UPDATE_TAG_CONTEXT_REQUEST = 'UPDATE_TAG_CONTEXT_REQUEST';

export const getTags = (params, callback) => ({
    type: GET_TAGS_REQUEST,
    payload: { params, callback },
});

export const getAssignableTags = (params, callback) => ({
    type: GET_ASSIGNABLE_TAGS_REQUEST,
    payload: { params, callback },
});

export const createTag = (tagData, callback) => ({
    type: CREATE_TAG_REQUEST,
    payload: { tagData, callback },
});

export const updateTag = (tagId, tagData, callback) => ({
    type: UPDATE_TAG_REQUEST,
    payload: { tagId, tagData, callback },
});

export const deleteTag = (tagId, callback) => ({
    type: DELETE_TAG_REQUEST,
    payload: { tagId, callback },
});

export const restoreTag = (tagId, callback) => ({
    type: RESTORE_TAG_REQUEST,
    payload: { tagId, callback },
});

export const getTagUsage = (tagId, callback) => ({
    type: GET_TAG_USAGE_REQUEST,
    payload: { tagId, callback },
});

export const setTagAssignments = (targetType, targetId, assignments, callback) => ({
    type: SET_TAG_ASSIGNMENTS_REQUEST,
    payload: { targetType, targetId, assignments, callback },
});

export const getInheritedTags = (params, callback) => ({
    type: GET_INHERITED_TAGS_REQUEST,
    payload: { params, callback },
});

export const getTagDetail = (tagId, callback) => ({
    type: GET_TAG_DETAIL_REQUEST,
    payload: { tagId, callback },
});

export const updateTagContext = (tagId, context, callback) => ({
    type: UPDATE_TAG_CONTEXT_REQUEST,
    payload: { tagId, context, callback },
});
